import { durationPresetDays, durationPresetKeys } from '../constants';

function inferDurationPreset(duracaoDias) {
  if (!duracaoDias) return durationPresetKeys.sem_prazo;
  if (duracaoDias === durationPresetDays[durationPresetKeys.seis_meses]) {
    return durationPresetKeys.seis_meses;
  }
  if (duracaoDias === durationPresetDays[durationPresetKeys.um_ano]) {
    return durationPresetKeys.um_ano;
  }

  return durationPresetKeys.personalizado;
}

export function parseProgramToForm(program) {
  if (!program) return null;

  const config = program.Config || {};
  const reward = program.Recompensa || {};
  const durationPreset = inferDurationPreset(program.DuracaoDias);

  return {
    id: program.Id,
    status: program.Status,
    type: program.Tipo,
    name: program.Nome,
    description: program.Descricao || '',
    validityDays: program.ValidadeBeneficioDias ?? '',
    durationPreset,
    durationCustomDays: durationPreset === durationPresetKeys.personalizado ? program.DuracaoDias ?? '' : '',
    cashbackModo: config.Modo || '',
    cashbackFixedValue: config.ValorFixo ?? '',
    cashbackPercentage: config.Percentual ?? '',
    cashbackGoalValue: config.ValorMetaAcumulo ?? '',
    goalQuantity: config.QuantidadeMeta ?? '',
    goalValue: config.ValorMeta ?? '',
    rewardType: reward.Tipo || '',
    rewardValue: reward.Valor ?? '',
    rewardPercentage: reward.Porcentagem ?? '',
  };
}
